import React, { useEffect, useState, useRef } from "react";
import { FlatList, ImageBackground, Pressable, ScrollView, StyleSheet, Switch, Text, TextInput as ReactText, TouchableOpacity, View, Alert } from "react-native";
import { MyButton, TextInputTemp } from "./buttonsAndControls";
import { Checkbox, IconButton, Modal, Portal, Provider as PaperProvider, TextInput } from "react-native-paper";
import DropDownPicker from "react-native-dropdown-picker";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { header, stopCodes } from "./StockAwareTempData";
const darkColour = '#2a2d3e';

interface ChildViewData {
  id: number;
  texts: string[];
}

interface PurchasedItems {
  id: number;
  texts: string[];
}

interface PurchasedList {
  ID: number;
  Quantity: number;
  Last_Updated: string;
	Vendor: string;
	Amount_Paid: number;
}

interface StockList {
  ID: number;
  Quantity: number;
  Item_Name: string;
	Item_Price: number;
  Last_Updated: string;
}

const Purchased = ({ texts, index, }: PurchasedItems & { index: number; }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const sizes: number[] = [57, 200, 300, 190 ];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity style={stylesBox.purchasedTouchable}>
        {texts.map((text, i) => (
          <View  
            key={i} 
            style={{...stylesBox.viewStyle, width: sizes[i] }}>
            <Text key={i} style={stylesBox.textStyle}>
              {text}
            </Text>
          </View>
        ))}
      </TouchableOpacity>
    </View>
  );
};

const ChildView = ({ texts, isChecked, isZero, onCheckboxChange, index, clickedItem, name, delPressed,
}: ChildViewData & { isChecked: boolean; isZero: boolean; onCheckboxChange: () => void;
  index: number; clickedItem: (name: string, checked: boolean)=> void; name: string; delPressed: (() => void); }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isZero ? 'red' : isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const sizes: number[] = [57, 370, 130, 216, 25 ];
	const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
				<Pressable style={{... stylesBox.childPressable, backgroundColor: isChecked 
						? darkColour : hovered ? '#CCCCCC' : 'transparent', opacity: isOpacity ? 0.2 : 1}}
					onPress={() => {onCheckboxChange(); clickedItem(name, isChecked);}}
					onHoverIn={() => setHovered(true)}
					onHoverOut={() => setHovered(false)}
					onPressIn={() => setIsOpacity(true)}
					onPressOut={() => setIsOpacity(false)}
				>
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.viewStyle, width: sizes[i] }}>
            <Text key={i} style={{...stylesBox.textStyle, color: isChecked ? 'white' : darkColour }}>
              {text}
            </Text>
          </View>
        ))}
				{hovered &&
					<IconButton icon={'trash-can-outline'}size={25} focusable={false} iconColor={isChecked ? 'white' : darkColour}  
					style={{justifyContent:'center', padding:0, margin:0, marginLeft: -5, alignContent:'center'}}
					onPress={() => delPressed()} />
				}
				</Pressable>
      </TouchableOpacity>
    </View>
  );
};


const ViewStock = () => {
	header('Stock View')	
  const [checkedItems, setCheckedItems] = useState<boolean[]>([]);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [searchText, setSearchText] = useState('');
	const [filteredResult, setFilteredResult] = useState<StockList[]>([]);
	const [stocks, setStocks] = useState<StockList[]>([]);
	const [purchasedItems, setPurchasedItems] = useState<PurchasedList[]>([]);
	const [oneOnly, setOneOnly] = useState('')
	const [showModal, setShowModal] = useState(false);
  const priceRef = useRef<ReactText>(null);
	const [iDToMark, setIDToMark] = useState('');
	const [boardName, setBoardName] = useState('')
	const [newPrice, setNewPrice] = useState('')

  const fetchStocks = async () => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        'SELECT * FROM Stocks ORDER BY ID DESC',
        [],
        (_, results) => {
          const rows = results.rows;
          const stocksArray: StockList[] = [];
          for (let i = 0; i < rows.length; i++) {
            stocksArray.push(rows.item(i) as StockList);
          }
          setStocks(stocksArray);
					setFilteredResult(stocksArray);
					const updatedCheckedItems: boolean[] = Array.from(
						{ length: stocksArray.length },
						() => false
					);
					setCheckedItems(updatedCheckedItems)
					
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  useEffect(() => {
		if (stopCodes) {
			try {
				fetchStocks();
					console.log('Stocky')
			} catch (error) {
					console.log(error)
			}
			setTimeout (() => {
			
			},200)
		}
		
  }, [stopCodes]);

	useEffect(() => {
		if (stopCodes) {
			const filterChildViews = async () => {
				const filteredViews = await filterViews() as StockList[];
				setFilteredResult(filteredViews);
			};

			filterChildViews();
			return () => {
			}
		}
	}, [stocks, isSwitchOn, searchText, stopCodes]);

	const handleCheckboxChange = ( name: string) => {
		if (oneOnly === name.toString()) {
			setOneOnly('')
		} else {
			setOneOnly(name)
		}

	};

  const handleSearchTextChange = (value: string) => {
    setSearchText(value);
  };

	const filterViews = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const filteredViews = stocks.filter((child) => {
				const hasTextMatch = (child.Item_Name.toLowerCase() + (child.Quantity ? child.Quantity.toString().toLowerCase() 
					: '') + (child.Item_Price ? child.Item_Price.toString().toLowerCase() : '')).includes(searchText.toLowerCase())
          const hasIdMatch = child.ID.toString().includes(searchText.toLowerCase());
          return hasTextMatch || hasIdMatch;
        });

        resolve(filteredViews);
      }, 0);
    });
  };

	const deleteFromDB = async (id: number) => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `DELETE FROM Stocks WHERE ID = ?;`,
        [id],
        (_, results) => {
         if (results.rowsAffected > 0) {
					console.log('Deleted Successfully')
				 }
					
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })

	};

  const deleteSelected = (id: number) => {
    const updatedChildViews = stocks.filter((item) => item.ID !== id);
    setStocks(updatedChildViews);
     deleteFromDB(id);
		 
  };
  
  const onToggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const switchText = isSwitchOn ? 'Price edit on' : 'Price edit off';

	const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [items, setItems] = useState([
    {label: 'Cash', value: 'Cash', icon: () => <IconButton icon="cash" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
    {label: 'POS', value: 'POS', icon: () => <IconButton icon="credit-card" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
		{label: 'Bank transfer', value: 'Bank transfer', icon: () => <IconButton icon="bank-transfer" iconColor={darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />}

	]);
	
	const addItemToScrollView = async (stockItem: string, iD: string) => {
		if (isSwitchOn){
			setShowModal(true)
			setBoardName(stockItem)
			setTimeout(() => {
				if (priceRef.current) {
				 priceRef.current.focus()
				}
			 }, 500); 
		}
	
		if (iDToMark !== iD) {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
		
			(await initDB).transaction((tx) => {
				tx.executeSql(
					'SELECT * FROM Purchase_Record WHERE Item_Name = ? ORDER BY ID DESC',
					[stockItem],
					(_, results) => {
						const rows = results.rows;
						const stocksArray: PurchasedList[] = [];
						for (let i = 0; i < rows.length; i++) {
							stocksArray.push(rows.item(i) as PurchasedList);
						}
						setPurchasedItems(stocksArray);
						const updatedCheckedItems: boolean[] = Array.from(
							{ length: stocksArray.length },
							() => false
						);
					},
					(error) => {
						console.error('Error executing SQL', error);
					}
				);
			})
			setIDToMark(iD)
		} else {
			setPurchasedItems([])
			setIDToMark('')
		}
	};
	
	const updatePrice = async () => {
	if (newPrice.charAt(0) === '0') {
		Alert.alert ("Zero is nothing", "Price can't be set to 0")
	} else if (newPrice.trim() === ''|| isNaN(parseInt(newPrice, 10))) {
		Alert.alert ('Ooops!', 'You have not entered an acceptable value') 
	} else {
		
		DEBUG(true);
		enablePromise(true);
		const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
		await (await initDB).transaction((tx) => {
			tx.executeSql('UPDATE Stocks SET Item_Price = ? WHERE Item_Name = ? ',
				[parseInt(newPrice, 10), boardName],
			);
		})
		setShowModal(false)
		setBoardName('')
		setNewPrice('')
	}
	};

	return (
		<PaperProvider>
			<View style={{ flex: 1 }}>
				<View style={stylesBox.mainView}>
					<View style={stylesBox.firstSubView}>
						<Switch
							value={isSwitchOn}
							onValueChange={onToggleSwitch}
							thumbColor={isSwitchOn ? 'white' : darkColour}
							trackColor={{ false: 'transparent', true: darkColour }}
							style={{ marginTop: -2, marginLeft: 8 }}
						/>
						<Text style={{ ...stylesBox.columnHeaderText, color: darkColour, marginTop: 8 }}>
							{switchText}
						</Text>
					</View>
		
					<View style={stylesBox.searchMainContainer}>
						<View style={{ flexDirection: 'row', width:380 }}>
							<TextInput
								mode="outlined"
								label={'Search stock'}
								placeholder="Search"
								underlineColor={darkColour}
								activeOutlineColor={darkColour}
								spellCheck={false}
								contentStyle={stylesBox.searchContentStyle}
								style={{ marginTop: -1, height: 30 }}
								outlineStyle={{ borderWidth: 0, height: 30, borderRightColor: 'white' }}
								onChangeText={handleSearchTextChange}
							/>
						</View>
					</View>
				</View>
				<View style={{flexDirection:'row'}}>
					<View style={stylesBox.stockViewBox}>
						<View style={stylesBox.stockViewHeader}>
							<View style={{ ...stylesBox.columnHeaderBox, marginLeft: 0, width: 59, borderLeftWidth: 0 }}>
								<Text style={{ ...stylesBox.columnHeaderText }}>Qty</Text>
							</View>
							<View style={{ ...stylesBox.columnHeaderBox, width: 370 }}>
								<Text style={{ ...stylesBox.columnHeaderText }}>Board Description</Text>
							</View>
							<View style={{ ...stylesBox.columnHeaderBox, width: 130 }}>
								<Text style={{ ...stylesBox.columnHeaderText }}>Last Purchase</Text>
							</View>
							<View style={{ ...stylesBox.columnHeaderBox, width: 216 }}>
								<Text style={{ ...stylesBox.columnHeaderText }}>Price per Board (₦)</Text>
							</View>
							<View style={{ ...stylesBox.columnHeaderBox, width: 25, borderRightWidth:0 }}>
								<Text style={{ ...stylesBox.columnHeaderText }}></Text>
							</View>
						</View>
						<ScrollView>
							{filteredResult.map((item, index) => (
								<ChildView
									key={item.ID}
									texts={[item.Quantity.toString(), item.Item_Name, item.Last_Updated, 
										item.Item_Price ? Number(item.Item_Price).toLocaleString('en-NG') : '0.00']}
									isChecked={oneOnly === item.Item_Name ? true : false}
									onCheckboxChange={() => handleCheckboxChange( item.Item_Name)}
									index={index}
									id={item.ID}
									isZero = {item.Quantity < 1 ? true : false}
									name= {item.Item_Name}
									clickedItem={()=> addItemToScrollView(item.Item_Name, item.ID.toString())}
									delPressed={() => deleteSelected(item.ID)}
								/>
							))}
						</ScrollView>
						<Portal>
							<Modal visible={showModal} onDismiss={() => {setShowModal(false); setBoardName(''); setNewPrice('')}} 
								contentContainerStyle={stylesBox.modalContainer}>
								<View>
									<View style ={stylesBox.modalChild}>
										<TextInputTemp refObject={priceRef} lTxt="Price" plhrTxt="Enter new price" cnWidth={250} 
											txtWidth={150} lbWidth={100} makeDigits ={true} onChangeText={(value)=>setNewPrice(value)} 
											enterKeyIsSunmit = {true} onSubmit={updatePrice}
										/>
										<View style={stylesBox.modalButtonContainer}>
											<View>
												<MyButton btnText="Update" btnWidth={120} hndClicked={updatePrice} />
											</View>
										</View>
									</View>
								</View>
							</Modal>
						</Portal>
					</View>
					<View style={{flexDirection:'column'}}>
						<View style={stylesBox.purchasedViewBox}>
							<View style={stylesBox.purchasedHeader}>
								<View style={{ ...stylesBox.columnHeaderBox, marginLeft: 0, width: 59, borderLeftWidth: 0 }}>
									<Text style={{ ...stylesBox.columnHeaderText }}>Qty</Text>
								</View>
								<View style={{ ...stylesBox.columnHeaderBox, width: 200 }}>
									<Text style={{ ...stylesBox.columnHeaderText }}>Date & Time</Text>
								</View>
								<View style={{ ...stylesBox.columnHeaderBox, width: 300 }}>
									<Text style={{ ...stylesBox.columnHeaderText }}>Vendor</Text>
								</View>
								<View style={{ ...stylesBox.columnHeaderBox, width: 184, borderRightWidth: 0 }}>
									<Text style={{ ...stylesBox.columnHeaderText }}>Cost (₦)</Text>
								</View>
							</View>

							<ScrollView>
								{purchasedItems.map((item, index) => (
									<Purchased
										key={item.ID}
										texts={[item.Quantity.toString(), item.Last_Updated, item.Vendor, 
											item.Amount_Paid ? Number(item.Amount_Paid).toLocaleString('en-NG') : '0.00']}
										index={index}
										id={item.ID}
									/>
								))}
							</ScrollView>
						</View>
					</View>
				</View>
			</View>
		</PaperProvider>
	)
}

const stylesBox=StyleSheet.create ({
	purchasedTouchable: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: 'transparent',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
	viewStyle: {
		borderWidth: 2, 
		borderColor: 'black', 
		height: 35, 
		alignItems: 'center', 
		marginLeft: -2, 
		borderTopWidth: 0, 
		borderBottomWidth: 0,
	},
	textStyle: {
		color: darkColour,
		fontFamily: 'century gothic', 
		fontSize: 15, 
		fontWeight: 'normal',
		marginTop: 6,
	},
	childPressable: {
		flexDirection: 'row',
		alignItems: 'center',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
	searchContentStyle: {
		paddingTop: 2,
		paddingBottom: 0,
		borderWidth: 2,
		borderRightWidth: 0,
		borderRightColor: 'white',
		width: 380,
		height: 30,
		borderRadius: 10,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderColor: 'transparent',
	},
	mainView: {
		flexDirection: 'row', 
		backgroundColor: 'white', 
		borderWidth: 2, 
		borderRadius: 10, 
		marginLeft: 20, 
		marginRight: 20, 
		borderColor: '#DCE3E8',
	},
	firstSubView: {
		borderWidth: 2,
		borderRadius: 10,
		borderColor: '#DCE3E8',
		flexDirection: 'row',
		alignSelf: 'center',
		alignContent: 'center',
		width: 208,
		height: 40,
		margin: 20,
		marginTop: 0,
		marginBottom: 0
	},
	searchMainContainer: {
		flexDirection: 'column',
		backgroundColor: 'white',
		alignSelf: 'center',
		borderWidth: 2,
		borderColor: '#DCE3E8',
		borderRadius: 10,
		marginLeft: 10,
		marginTop: 10,
		marginBottom: 10,
		height: 40
	},
	stockViewBox: {
		width: 800,
		height: 660,
		borderWidth: 2,
		borderColor: '#DCE3E8',
		marginTop: 10,
		marginBottom: 0,
		borderRadius: 10,
		marginLeft: 20,
		marginRight: 20,
		backgroundColor: 'white',
	},
	stockViewHeader: {
		width: 797,
		height: 35,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
	modalChild: {
    width: 350, 
    height:120, 
    borderWidth:2, 
    borderRadius:10, 
    borderColor:darkColour, 
    backgroundColor:'white',
  },
  modalButtonContainer: {
    width:350, 
    alignItems:'center',
		justifyContent:'center', 
  },
	modalContainer: {
		marginLeft:600,
		marginTop: -50,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'white',
		flexDirection:'column-reverse', 
		width:350, 
		height:120, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  },
	purchasedViewBox: {
		width:740,
		height: 660,
		borderWidth: 2,
		borderColor: '#DCE3E8',
		marginTop: 10,
		marginBottom: 0,
		borderRadius: 10,
		marginLeft: 0,
		marginRight: 20,
		backgroundColor: 'white',
	},
	purchasedHeader: {
		width: 737,
		height: 35,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
	columnHeaderText: {
	fontFamily:'century gothic', 
	fontSize:15, 
	fontWeight:'normal', 
	textAlign:'center',
	color:'white', 
	marginTop:6
	},

	columnHeaderBox: {
		borderWidth:2, 
		borderColor:'black', 
		width:57,  
		height:35, 
		alignItems:'center',
		marginLeft:-2,
		borderTopWidth:0,
		
	},
	
	mediumText: {
	color:'grey', 
	fontFamily:'century gothic', 
	fontSize:15, 
	fontWeight:'normal', 
	textAlign:'center',
	marginTop:5
	},
			
	})

export default ViewStock